// src/utils/ToasterMessage.js
import { toast } from "react-hot-toast";

const ShowToastMsg = ({
  type = "success",
  toastText = "",
  duration = 3000,
  position = "bottom-right-corner",
}) => {
  const baseOptions = {
    duration,
    position,
  };

  switch (type) {
    case "success":
      toast.success(toastText, baseOptions);
      break;
    case "error":
    case "fail":
    case "danger":
      toast.error(toastText, baseOptions);
      break;
    case "loading":
      toast.loading(toastText, baseOptions);
      break;
    case "normal":
    default:
      toast(toastText, baseOptions);
  }
};
export default ShowToastMsg;
